// extracted by mini-css-extract-plugin
module.exports = {"makrExcelBtn":"makr_makrExcelBtn__3EZou","makrGrid":"makr_makrGrid__FgU5k","makrExcelBtnClass":"makr_makrExcelBtnClass__1PRUS"};